import { provideStates } from '@ngxs/store';
import { ClientIntakeFormItemsState } from './state/clientIntakeFormItems.firebase.state';

export const PROVIDE_CLIENT_INTAKE_FORM_ITEMS_STATE = [
	provideStates([ClientIntakeFormItemsState]),
];
